import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["accept", "multiple"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_ctx.containerStyle),
    onDragover: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.dragOver = true), ["prevent"])),
    onDragleave: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.dragOver = false), ["prevent"])),
    onDrop: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"])),
    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
  }, [
    _createElementVNode("input", {
      type: "file",
      ref: "fileInput",
      style: {"display":"none"},
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args))),
      accept: _ctx.accept,
      multiple: _ctx.multiple
    }, null, 40, _hoisted_1),
    _createElementVNode("div", null, [
      (_ctx.name)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle(_ctx.uploadedRowStyle)
          }, [
            _createElementVNode("span", {
              style: _normalizeStyle(_ctx.fileNameStyle)
            }, _toDisplayString(_ctx.name), 5),
            _createElementVNode("span", {
              style: _normalizeStyle(_ctx.browseStyle),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('handleFileDownload')), ["prevent","stop"]))
            }, "Download", 4),
            _createElementVNode("button", {
              type: "button",
              class: "remove-file-btn",
              style: _normalizeStyle(_ctx.removeButtonStyle),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('handleFileRemove')), ["prevent","stop"]))
            }, " Remove ", 4)
          ], 4))
        : _createCommentVNode("", true),
      _createElementVNode("p", {
        style: _normalizeStyle(_ctx.textStyle)
      }, [
        _createTextVNode(" Drag & drop your file here " + _toDisplayString(_ctx.accept) + " or ", 1),
        _createElementVNode("span", {
          style: _normalizeStyle(_ctx.browseStyle)
        }, "browse", 4)
      ], 4),
      (_ctx.files.length)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            style: _normalizeStyle(_ctx.fileListStyle)
          }, " Selected: " + _toDisplayString(_ctx.fileNames), 5))
        : _createCommentVNode("", true)
    ]),
    (_ctx.files.length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          style: _normalizeStyle(_ctx.buttonStyle),
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadFiles && _ctx.uploadFiles(...args)), ["stop"]))
        }, " Upload ", 4))
      : _createCommentVNode("", true)
  ], 36))
}